import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioGeralReducer(state = initialState.relatorioGeral, action){
    switch(action.type) {
        case types.RELAT_DIRECIONAMENTO_GRUPOTRATAMENTO:
            return {...state, direcionarGrupoTratamento: action.payload};
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioGeralReducer.js
 **/